/* eslint-disable no-new-func */

// We run it inside web worker, so it can be safely executed. It is impossible to access user's data from a web worker
import dayjs from 'dayjs';
import { getDateFromString } from '../time-format';
import { DATE_FORMAT } from '../constants';

const addYears = (oldDate, amountYears) => {
  const date = getDateFromString(oldDate, {
    input: 'DD/MM/YYYY'
  });

  return dayjs(date).add(amountYears, 'years').format(DATE_FORMAT);
};

const transformers = [addYears];
const transformerNames = ['addYears'];

export function evaluate(value, params) {
  const paramsNames = Object.keys(params);
  const paramsValues = Object.values(params);

  const returnFunc =
    typeof value === 'string'
      ? 'try { return `' + value + '`; } catch (e) { return `Syntax error ${e}`}' // eslint-disable-line no-template-curly-in-string
      : 'try { return ' + value + '; } catch (e) { return `Syntax error ${e}`}'; // eslint-disable-line no-template-curly-in-string

  // eslint-disable-next-line no-new-func
  return Function(...paramsNames, ...transformerNames, returnFunc)(...paramsValues, ...transformers);
}
